module.exports = __webpack_public_path__ + "img/logo_bpjstk2.5b1a6778.png";